import { render, staticRenderFns } from "./v-inpage-links.vue?vue&type=template&id=0febdefc&scoped=true&"
import script from "./v-inpage-links.vue?vue&type=script&lang=js&"
export * from "./v-inpage-links.vue?vue&type=script&lang=js&"
import style0 from "./v-inpage-links.vue?vue&type=style&index=0&id=0febdefc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0febdefc",
  null
  
)

export default component.exports